export enum Region {
    EuIreland = "eu-west-1",
    UsEastNVirginia = "us-east-1"
}
